import { toastr } from "react-redux-toastr";

export const CheckIsExist = error => {
  return (
    error.response &&
    error.response.data &&
    error.response.data.message &&
    Array.isArray(error.response.data.message)
  );
};

export const SetMessage = (error, toast) => {
  let message = "";
  if (!error.response && error.message === "Network Error") {
    message = [
      "دسترسی به سرور مقدور نمی‌باشد. لطفاً پس از بررسی اتصال اینترنت خود، مجددا تلاش کنید."
    ];
  } else if (CheckIsExist(error)) {
    message = error.response.data.message;
  } else {
    message = [
      "در دریافت اطلاعات از سرور خطایی رخ داده است، لطفاً مجددا تلاش نمایید."
    ];
  }
  if (toast) {
    message.forEach(message => {
      toastr.error(" ", message.toString());
    });
  }
  return message;
};

export const concatAllErrors = error => {
  let message = "";
  if (CheckIsExist(error)) {
    message = error.response.data.message.reduce((res, mes) => res + mes, "");
  }
  return message;
};
